module.exports = __webpack_public_path__ + "img/digital_wire_top2.a7ce7fd6.svg";